export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const AUTHENTICATED = "AUTHENTICATED";
export const SETUSERCUSTOMERLIST = "SETUSERCUSTOMERLIST";
